import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { LoadingSpinner } from './LoadingSpinner';

import type { DescriptionEditorProps } from './DescriptionEditorProps';

export const LazyDescriptionEditor: FunctionComponent<DescriptionEditorProps> = (
  props,
) => {
  const DescriptionEditor = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "description-editor" */ './DescriptionEditor'
      ),
    { namedImport: 'DescriptionEditor', preload: false },
  );

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <DescriptionEditor {...props} />
    </Suspense>
  );
};
